import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { IpPublicService } from '../../../../services/ip-public.service';
import { ModalService } from '../../../../services/modal.service';
import { AlertService } from '../../../../services/alert.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { Aplicacion } from '../../models/aplicacion';
import { AplicacionesService } from '../../services/aplicaciones.service';
import { AplicacionPermisoService } from '../../services/aplicacion-permiso.service';

@Component({
  selector: 'app-aplicaciones',
  templateUrl: './aplicaciones.component.html',
  styleUrls: ['./aplicaciones.component.css']
})
export class AplicacionesComponent implements OnInit, OnDestroy {
  breadCrumbItems = [{label: 'Administración Sistema'}, {label: 'Catálogos Sistemas'}, {label: 'Aplicaciones', active: true}];
  public formAplicacion!: UntypedFormGroup;
  public submitted = false;
  private currentUser!: any;
  private ipAddress!: string;
  private buffer!: any;
  public dataApp: any[] = [];
  private idDeleteRegister: number = 0;
  public selectItems: any[] = [];
  public nameModal: string = 'modalAplicacion'
  nameApp = 'APLICACIONES';

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  isDtInitialized: boolean = false;

  constructor(
    private fb: FormBuilder,
    private aplicacionService: AplicacionesService,
    private alert: AlertService,
    private ip: IpPublicService,
    public modal: ModalService,
    private aplicacionPermisoService:AplicacionPermisoService,
  ) {
    this.buffer = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.buffer);
    this.selectItems = [
      { value: '', label: 'Seleccione' },
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];
  }

  get rolForm() {
    return this.formAplicacion.controls;
  }

  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }

  setForm() {
    this.formAplicacion = this.fb.group({
      idSprAplicacion: [],
      nombre: ['', [Validators.required]],
      descripcion: ['', [Validators.required]],
      estado: ['', [Validators.required]],
    });
    this.formAplicacion.patchValue({
      estado: this.selectItems[0].value,
    });
  }

  initApp() {
  this.listDataApp();
  this.setDataTable();
  this.setForm();
  }
  ngOnInit(): void {
    this.getIpPublic();
    this.initApp();
  }
  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  listDataApp() {
    this.aplicacionService.list().subscribe((resp) => {
      this.dataApp = resp;
      this.reDrawDataTable();
    });
  }

  reDrawDataTable() {
    // Redibujar la tabla al actualizar datos
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }

  onSubmit() {
    this.submitted = true;
    this.formAplicacion.value.usuario = this.currentUser.idSprUsuario;
    this.formAplicacion.value.ip = this.ipAddress;
    if (!this.formAplicacion.invalid) {
      if (this.formAplicacion.value.idSprAplicacion == null) {
        if (this.listAplicacionExisteDiferente(this.formAplicacion.value.nombre, this.formAplicacion.value.idSprAplicacion)) {
        this.aplicacionService.create(this.formAplicacion.value).subscribe(
          (resp) => {
            this.initApp();
            this.modal.close();
            this.alert.createOk();
          },
          (err) => {
            this.alert.createError();
          }
        );
      }
      } else {
        if (this.listAplicacionExisteDiferente(this.formAplicacion.value.nombre, this.formAplicacion.value.idSprAplicacion)) {
        this.aplicacionService.update(this.formAplicacion.value).subscribe(
          (resp) => {
            this.initApp();
            this.modal.close();
            this.alert.updateOk();
          },
          (err) => {
            this.alert.updateError();
          }
        );
      }
      }
    } else {
      return;
    }
  }


  listAplicacionExisteDiferente(nombre: any, idSprAplicacion: any) {
    let vector: any = [];
    let vectorFiltrado: any = [];
    let nombresInicio = nombre.trimStart();
    let nombresFin = nombresInicio.trimEnd();
    vector = this.dataApp;
    for (let elemento of vector) {
      if (elemento.idSprAplicacion !== idSprAplicacion) {
        vectorFiltrado.push(elemento);
        //return false;
      }
    }
    for (let elemento of vectorFiltrado) {
      if (elemento.nombre == nombresFin) {
        this.alert.warning('¡Atención!',"Existe una aplicación con el mismo nombre.")
        return false;
      }
    }
    return true;
  }

  edit(obj: Aplicacion) {
    this.openModal();
    this.formAplicacion.patchValue({
      idSprAplicacion: obj.idSprAplicacion,
      descripcion: obj.descripcion,
      nombre: obj.nombre,
      estado: obj.estado,
    });
  }

  delete(idRegister:number) {
    this.modal.open('delete-aplicacion');
   this.idDeleteRegister= idRegister;
  }
   /////////////////VERIFICA LOS HITOS RLACIONADOS///////////////////////
 verifyAplicacionRol() {
  return this.aplicacionPermisoService.list(`?idSprAplicacion=${this.idDeleteRegister}&delLog=N`).toPromise();
}
/////////////////////////////////////////////////////////////////////////

async confirmDelete() {

  let confirmDelete = true;
  let dataVerifyRelacion: any = [];
  //##############  verificacion1 si existe datos relacionado ########################
  dataVerifyRelacion = await this.verifyAplicacionRol();
  (dataVerifyRelacion.length > 0) ? confirmDelete = false : "";
  //###################################################################################

    if (confirmDelete) {
      this.aplicacionService.delete(
        {"idSprAplicacion":this.idDeleteRegister,
        "usuario":this.currentUser.idSprUsuario,
        "delLog":"S",
        "ip":this.ipAddress
      }
      )
        .subscribe(resp => {
          this.initApp();
          this.modal.close()
         this.alert.deleteOk();
        }, (err) => {
          this.alert.deleteError();
        });
      }
      else {
        this.alert.EliminarRegistro();
      }
  }

  openModal() {
    this.onResetForm();
    this.modal.open(this.nameModal);
  }

  onResetForm(){
    this.submitted = false;
    this.formAplicacion.reset();
  }
}
